import { Store } from 'vuex';
import { inject, injectable } from 'inversify-props';
import { UniquePromise, ICommand, eventBus, mcLogger } from '@/utils';
import { types } from '@/store';
import { ICounterApi } from '@/apis';
import { AxiosResponse } from 'axios';
import { SyncCommandResult } from '@/models';

/** Pulls down any changes for specified local meals down from the server */
@injectable()
export class SyncMealsUpCommand implements ICommand<null> {
  @inject() private store!: Store<any>;
  @inject() private counterApi!: ICounterApi;

  private console: Console = mcLogger.getConsole(this.constructor.name, 'darkcyan');

  private promise = new UniquePromise(false);
  private isSyncing: boolean = false;

  async run() {
    return this.promise.run(async () => {
      if (!this.isSyncing && this.store.state.auth.isAuthenticated && navigator.onLine && this.needSync) {
        this.isSyncing = true;
        const payload = this.store.state.meals.syncUpCounts;
        if (payload.length > 0) {
          const response = await this.counterApi.syncMealsUp(payload);
          await this.clearSyncUpCounts(response);
        }
        this.isSyncing = false;
      }
    });
  }

  private get needSync() {
    const result = this.store.state.meals.syncUpCounts.length > 0;
    return result;
  }

  private async clearSyncUpCounts(response: AxiosResponse<SyncCommandResult>) {
    if (response.status === 200 && response.data.state === "Successful") {
      await this.store.dispatch(types.actions.clearSyncUp);
      eventBus.$emit('syncNotice');
    }
  }
}
